module.exports = __webpack_public_path__ + "img/m-banner-csrrksao-en-US.e8eaf239.jpg";